(() => {
  const COLLECTION_PARAM = 'gr_collection';
  const PRICE_PARAM = 'gr_price';
  const AVAILABILITY_PARAM = 'gr_availability';
  const NATIVE_AVAILABILITY_PARAM = 'filter.v.availability';
  const LEGACY_NATIVE_PRICE_MIN = 'filter.v.price.gte';
  const LEGACY_NATIVE_PRICE_MAX = 'filter.v.price.lte';

  const getParams = () => new URLSearchParams(window.location.search);

  const getSelectedValues = (param, params = getParams()) =>
    new Set(params.getAll(param).filter(Boolean));

  const syncCollectionInputs = () => {
    const selected = getSelectedValues(COLLECTION_PARAM);
    document.querySelectorAll('[data-gr-collection-filter]').forEach((input) => {
      input.checked = selected.has(input.value || input.dataset.grCollectionFilter || '');
    });
  };

  const syncPriceInputs = () => {
    const selected = getSelectedValues(PRICE_PARAM);
    document.querySelectorAll('[data-gr-price-band]').forEach((input) => {
      input.checked = selected.has(input.value || '');
    });
  };

  const normalizeAvailabilityValue = (value) => {
    if (value === '1' || value === 'in' || value === 'true') return 'in';
    if (value === '0' || value === 'out' || value === 'false') return 'out';
    return '';
  };

  const syncAvailabilityInputs = () => {
    const params = getParams();
    const selected = normalizeAvailabilityValue(params.get(AVAILABILITY_PARAM) || '');

    document.querySelectorAll('[data-gr-availability-filter]').forEach((input) => {
      input.checked = selected !== '' && input.value === selected;
    });

    document.querySelectorAll('.gr-availability-select[data-gr-whole-product-availability]').forEach((select) => {
      const input = select.querySelector('input[name="gr_availability"]');
      const text = select.querySelector('.custom-select--text');
      if (input) input.value = selected;
      if (text) text.textContent = selected === 'in' ? 'In stock' : selected === 'out' ? 'Out of stock' : 'Availability';

      select.querySelectorAll('.custom-select--item button').forEach((button) => {
        const active = (button.dataset.value || '') === selected;
        button.classList.toggle('custom-select--item-active', active);
        if (active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    });
  };

  const updateMobileSelectionCount = () => {
    const params = getParams();
    let count = params.getAll(COLLECTION_PARAM).filter(Boolean).length;
    count += params.getAll(PRICE_PARAM).filter(Boolean).length;
    if (normalizeAvailabilityValue(params.get(AVAILABILITY_PARAM) || '')) count += 1;

    const countedKeys = new Set();
    params.forEach((_value, key) => {
      if (!key.startsWith('filter.')) return;
      if (key === NATIVE_AVAILABILITY_PARAM) return;
      if (key === LEGACY_NATIVE_PRICE_MIN || key === LEGACY_NATIVE_PRICE_MAX) {
        countedKeys.add('native-price-range');
      } else {
        countedKeys.add(key);
      }
    });
    count += countedKeys.size;

    document.querySelectorAll('.mobile-filter-selection-count').forEach((element) => {
      element.classList.toggle('is-empty', count === 0);
      element.textContent = count > 0 ? `${count} selected` : '';
    });
  };

  const syncRetailState = () => {
    syncCollectionInputs();
    syncPriceInputs();
    syncAvailabilityInputs();
    updateMobileSelectionCount();
  };

  const updateHistory = (params, replace = false) => {
    params.delete('page');
    const query = params.toString();
    const url = `${window.location.pathname}${query ? `?${query}` : ''}`;
    const state = { searchParams: query };

    if (replace) history.replaceState(state, '', url);
    else history.pushState(state, '', url);

    if (typeof FacetFiltersForm !== 'undefined') {
      FacetFiltersForm.searchParamsPrev = query;
    }
  };

  const dispatchCustomFilterChange = () => {
    window.dispatchEvent(new CustomEvent('gear-rack:custom-filters-changed', {
      detail: { searchParams: window.location.search }
    }));
  };

  const updateCustomCheckbox = (input, param) => {
    const params = getParams();
    const value = input.value || '';
    const selected = getSelectedValues(param, params);

    if (input.checked) selected.add(value);
    else selected.delete(value);

    params.delete(param);
    selected.forEach((item) => params.append(param, item));

    if (param === PRICE_PARAM) {
      params.delete(LEGACY_NATIVE_PRICE_MIN);
      params.delete(LEGACY_NATIVE_PRICE_MAX);
    }

    updateHistory(params);
    syncRetailState();
    dispatchCustomFilterChange();
  };

  const setWholeProductAvailability = (value) => {
    const params = getParams();
    const normalized = normalizeAvailabilityValue(value);

    params.delete(NATIVE_AVAILABILITY_PARAM);
    if (normalized) params.set(AVAILABILITY_PARAM, normalized);
    else params.delete(AVAILABILITY_PARAM);

    updateHistory(params);
    syncRetailState();
    dispatchCustomFilterChange();
  };

  document.addEventListener('input', (event) => {
    const collectionInput = event.target.closest?.('[data-gr-collection-filter]');
    if (collectionInput) {
      event.preventDefault();
      event.stopPropagation();
      updateCustomCheckbox(collectionInput, COLLECTION_PARAM);
      return;
    }

    const availabilityInput = event.target.closest?.('[data-gr-availability-filter]');
    if (availabilityInput) {
      event.preventDefault();
      event.stopPropagation();
      setWholeProductAvailability(availabilityInput.checked ? availabilityInput.value : '');
      return;
    }

    const priceInput = event.target.closest?.('[data-gr-price-band]');
    if (priceInput) {
      event.preventDefault();
      event.stopPropagation();
      updateCustomCheckbox(priceInput, PRICE_PARAM);
    }
  }, true);

  document.addEventListener('gear-rack:availability-select-change', (event) => {
    setWholeProductAvailability(event.detail?.value || '');
  });

  window.addEventListener('popstate', () => {
    syncRetailState();
    dispatchCustomFilterChange();
  });

  window.addEventListener('gear-rack:facets-rendered', () => {
    syncRetailState();
  });

  document.addEventListener('shopify:section:load', () => {
    syncRetailState();
    dispatchCustomFilterChange();
  });

  const init = () => {
    const params = getParams();
    let changed = false;

    if (params.getAll(PRICE_PARAM).some(Boolean) && (params.has(LEGACY_NATIVE_PRICE_MIN) || params.has(LEGACY_NATIVE_PRICE_MAX))) {
      params.delete(LEGACY_NATIVE_PRICE_MIN);
      params.delete(LEGACY_NATIVE_PRICE_MAX);
      changed = true;
    }

    if (params.has(NATIVE_AVAILABILITY_PARAM)) {
      const migrated = normalizeAvailabilityValue(params.get(NATIVE_AVAILABILITY_PARAM) || '');
      params.delete(NATIVE_AVAILABILITY_PARAM);
      if (migrated) params.set(AVAILABILITY_PARAM, migrated);
      changed = true;
    }

    if (changed) updateHistory(params, true);
    syncRetailState();
    if (changed) dispatchCustomFilterChange();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
